<template>
    <div>
        <!--Contact Info Wrap Start-->
    <!--        <div class="iq_contact_info">
                <div class="container">
                    <ul>
                        <li>
                            <i class="fa fa-map-marker"></i>
                            <div class="iq_info_wrap">
                                <h5>LE NIVEAU Address</h5>
                                <span>Block A2-5 suite 62 Shopping complex, Simpson street, Lagos Island Nigeria</span>
                            </div>
                        </li>
                        <li>
                            <i class="fa fa-phone"></i>
                            <div class="iq_info_wrap">
                                <h5>Contact Number</h5>
                                <span>+2348020581622</span>
                            </div>
                        </li>
                        <li>
                            <i class="fa fa-phone"></i>
                            <div class="iq_info_wrap">
                                <h5>Email;</h5>
                                <a href="info@leniveauconsult.com ">info@leniveauconsult.com </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>-->
            <!--Contact Info Wrap End-->
            <!--Footer Wrap Start-->
            <footer class="iq_footer_bg">
              <div class="container-fluid">
                <div class="row">
                        <!--Widget About Start-->
                  <div class="col-md-3 col-sm-6">
                    <div class="iq_uni_title">
                                <!--footer logo Start-->
                      <div class="footer_logo">
                            <a href="http://leniveauconsult.com/">
                                <img src="../assets/extra-images/logo-white.png" alt="Le Niveau consult">
                            </a>
                        </div>
                                <!--footer logo End-->
                        <p>Le Niveau Consult Limited is a registered Nigerian based Consultancy firm with an International branch in Abidjan Cote Ivoire.   It was established with the aim of providing high quality services to our client.</p>

                    </div>
                  </div>
                  <!--Widget About End-->
                        <!--Widget Archive Start-->
                  <div class="col-md-3 col-sm-6">
                            <div class="widget widget_archive">
                                <!--Widget Title Start-->
                                <h5 class="widget-title"><span>Our</span> Services</h5>
                                <!--Widget Title End-->
                                <!--Social Media Start-->
                                <ul>
                                    <li>
                                        <a href="#">Student Counselling</a>
                                    </li>
                                    <li>
                                        <a href="#">Direct Placement</a>
                                    </li>
                                    <li>
                                        <a href="#">Pre-depature Briefing</a>
                                    </li>
                                    <li>
                                        <a href="#">Network Opportunities</a>
                                    </li>
                                    <li>
                                        <a href="https://server181.web-hosting.com:2096/">Webmail</a>
                                    </li>
                                </ul>
                                <!--Social Media End-->
                            </div>
                  </div>
                        <!--Widget Archive End-->
                        <!--Widget Flickr Start-->
                        <div class="col-md-3 col-sm-6">
                            <div class="iq_uni_title">
                                <!-- Widget Title Start-->
                                <h5 class="widget-title"><span>Our</span> Address</h5>
                                <p class="mb-3"><i class="fa fa-map-marker"></i> LAGOS: Block A2-5 suite 62 Shopping complex, Simpson street, Lagos Island </p>
                              <p class="mb-3"><i class="fa fa-map-marker"></i> ABUJA: 4 Ayin Pius Anyin Street, CBS Great estate, Off Emmanuel Mbaka Bolvd, Abuja</p>

                              <ul class="">
                                    <li><span>Monday - Friday</span> 08:00- 05:00</li>
                                </ul>
                                <!-- Widget Title End-->

                            </div>
                        </div>
                        <!--Widget Flickr End-->
                        <!--Widget News Letter Start-->
                  <div class="col-md-3 col-sm-6">
                    <div class="widget iq_footer_newsletter">
                                <!--Widget Title Start-->
                      <h5 class="widget-title border-none"><span>Follow</span> Us</h5>
                      <p>Follow us on social media</p>
                                <!--Widget Title Start-->
                      <ul class="iq_footer_social">
                        <li>
                          <a href="https://www.facebook.com/Le-Niveau-Consult-139194592885304/" target="_blank"><i class="fa fa-facebook"></i></a>
                        </li>
                        <li>
                          <a href="https://twitter.com/leniveaultd" target="_blank"><i class="fa fa-twitter"></i></a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/company/le-niveau-consult/?viewAsMember=true" target="_blank"><i class="fa fa-linkedin" ></i></a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/studywithleniveau/" target="_blank"><i class="fa fa-instagram"></i></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                        <!--Widget News Letter End-->
                </div>
              </div>
            </footer>
            <!--Footer Wrap End-->
            <!--Copy Right Start-->
      <div class="footer_strip">
<!--        <h5>© 20120 Developed by <a target="_blank" href="https://www.grandilo.com">Grandilo Technology</a></h5>-->
      </div>
      <!--Copy Right End-->

    </div>
</template>
<script>
export default {
    name: "footers"
}
</script>
<style>
    .footer_logo {
    position: relative;
    margin: 0 0 37px;
    /* padding: 22px 0 0; */
}
.footer_logo a img {
    display: block;
    height: 45px;
    width: auto;
}
.iq_footer_bg{
    text-align: left !important;
    background-color:#102A5D !important;
    color:#fff !important;
}
.iq_uni_title p, .iq_footer_bg .widget_archive li a , .iq_footer_newsletter p{
    color: #fff !important
}
.footer_strip{
    background-color: #102A5D !important
}
</style>
